import { html, LitElement } from 'lit';

class IconYoutube extends LitElement {
  static properties = {
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    fillColor: {
      type: String,
      attribute: 'fill-color',
    },
  };

  constructor() {
    super();
    this.height = '24';
    this.width = '24';
    this.fillColor = '#ffffff';
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" fill="${this.fillColor}" width="${this.width}" height="${this.height}"  viewBox="0 0 24 24">
        <path d="M21.582,6.186c-0.23-0.86-0.908-1.538-1.768-1.768C18.254,4,12,4,12,4S5.746,4,4.186,4.418 c-0.86,0.23-1.538,0.908-1.768,1.768C2,7.746,2,12,2,12s0,4.254,0.418,5.814c0.23,0.86,0.908,1.538,1.768,1.768 C5.746,20,12,20,12,20s6.254,0,7.814-0.418c0.861-0.23,1.538-0.908,1.768-1.768C22,16.254,22,12,22,12S22,7.746,21.582,6.186z M10,15.464V8.536L16,12L10,15.464z"/>
      </svg>
    `;
  }
}
customElements.define('tenable-icon-youtube', IconYoutube);
